/* ==========================================================================
   Theme JS — Header scroll behavior, global event listeners
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  var announcementBar = document.querySelector('.announcement-bar');

  function getAnnouncementHeight() {
    return announcementBar ? announcementBar.offsetHeight : 0;
  }

  function onScroll() {
    var y = window.scrollY;
    var annHeight = getAnnouncementHeight();

    if (header) {
      /* Slide header up as announcement bar scrolls out of view */
      var headerTop = Math.max(0, annHeight - y);
      header.style.top = headerTop + 'px';

      /* Add scrolled state once announcement bar is fully hidden */
      if (y > annHeight) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      /* Set CSS custom property for just the header height
         (announcement bar is in flow and provides its own space) */
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile nav ---------- */
  var menuBtn = document.querySelector('.site-header__menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileNavClose = document.querySelector('.mobile-nav__close');

  function openMobileNav() {
    if (mobileNav) {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeMobileNav() {
    if (mobileNav) {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNav) {
    mobileNav.addEventListener('click', function(e) {
      if (e.target === mobileNav) closeMobileNav();
    });
  }

  /* ---------- Cart badge update ---------- */
  function updateCartBadge(count) {
    var badges = document.querySelectorAll('.site-header__cart-count');
    badges.forEach(function(badge) {
      badge.textContent = count > 0 ? count : '';
    });
  }

  /* Listen for cart:update event */
  document.addEventListener('cart:update', function(e) {
    if (e.detail && typeof e.detail.item_count !== 'undefined') {
      updateCartBadge(e.detail.item_count);
    }
  });

  /* ---------- Cart button opens drawer ---------- */
  var cartBtns = document.querySelectorAll('[data-cart-open]');
  cartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  });

  /* ---------- Fetch initial cart state ---------- */
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartBadge(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
    })
    .catch(function() {});

  /* ---------- Smooth scroll for anchor links ---------- */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (id === '#') return;
    var target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      var headerHeight = header ? header.offsetHeight : 0;
      var annHeight = getAnnouncementHeight();
      var y = window.scrollY;
      var visibleAnn = Math.max(0, annHeight - y);
      var offset = headerHeight + visibleAnn + 16;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });

})();
